import { FuelTypeCode } from '../models/vehicle.model';

export const getFuelTypeIcon = (code: FuelTypeCode) => {
  switch (code) {
    case FuelTypeCode.DIESEL:
    case FuelTypeCode.PETROL:
      return 'bds/fuel/24';
    case FuelTypeCode.ELECTRIC:
    case FuelTypeCode.DIESEL_ELECTRIC_PLUGIN_HYBRID:
    case FuelTypeCode.PETROL_ELECTRIC_PLUGIN_HYBRID:
      return 'bds/fuel-e/24';
    default:
      return 'bds/fuel/24';
  }
};
